import { Button, TFModals } from '@tf/ui';
import type React from 'react';
import { ConfirmationModal } from '@/components/shared';
import { useOrderAccountsExportMutation } from '@/core/api/dataExport';

export const OrderExportButton: React.FC = () => {
	const orderAccountsExportMutation = useOrderAccountsExportMutation();

	const orderExport = () => {
		TFModals.open({
			children: (
				<ConfirmationModal
					title="Data export"
					message="Please note data processing can take several minutes. Once the file is ready, you can download it by clicking the Download button in the All exports table."
					confirmText="Generate file"
					onConfirm={orderAccountsExportMutation.mutate}
				/>
			),
		});
	};

	return <Button onClick={orderExport}>Generate file</Button>;
};
